<template>
    <v-dialog v-model="listSettingsModal" max-width="700" persistent>
        <v-card>
            <v-card-title class="headline">{{ "Choose columns to show" | t }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0">{{
                "Select which fields will be displayed" | t
            }}</v-card-subtitle>
            <v-card-text>
                <!-- Names group -->
                <div class="group-header mt-4">{{ "Names" | t }}</div>
                <v-row no-gutters>
                    <v-col v-for="col in nameColumns" :key="col.value" md="4" sm="6">
                        <v-checkbox
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(col)"
                            :label="col.text | t"
                            :input-value="col.isSelected"
                        />
                    </v-col>
                </v-row>

                <!-- Type & description group -->
                <div class="group-header mt-4">{{ "Type & description" | t }}</div>
                <v-row no-gutters>
                    <v-col v-for="col in typeColumns" :key="col.value" md="4" sm="6">
                        <v-checkbox
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(col)"
                            :label="col.text | t"
                            :input-value="col.isSelected"
                        />
                    </v-col>
                </v-row>

                <!-- Location group -->
                <div class="group-header mt-4">{{ "Location" | t }}</div>
                <v-row no-gutters>
                    <v-col v-for="col in locationColumns" :key="col.value" md="4" sm="6">
                        <v-checkbox
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(col)"
                            :label="col.text | t"
                            :input-value="col.isSelected"
                        />
                    </v-col>
                </v-row>

                <!-- Business & integrations group -->
                <div class="group-header mt-4">{{ "Business & integrations" | t }}</div>
                <v-row no-gutters>
                    <v-col v-for="col in businessColumns" :key="col.value" md="4" sm="6">
                        <v-checkbox
                            hide-details
                            class="mt-0 mb-0"
                            @click.stop="toggleListSettingsColumn(col)"
                            :label="col.text | t"
                            :input-value="col.isSelected"
                        />
                    </v-col>
                </v-row>

                <!-- Select all / Deselect all buttons -->
                <v-row class="mt-4">
                    <v-col>
                        <v-btn text color="primary" @click="selectAllColumns">
                            {{ "Select all" | t }}
                        </v-btn>
                        <v-btn text color="grey" @click="deselectAllColumns">
                            {{ "Deselect all" | t }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="bal-dark-gray" text @click="toggleListSettingsModal">
                    {{ "Close" | t }}
                </v-btn>

                <v-btn color="bal-green" text @click="handleReturnClick">
                    {{ "Save" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar color="error" bottom :timeout="2500" :value="errorMsg">
            <div style="display: flex">
                <v-icon color="#FFF">error</v-icon>
                <div class="title pa-2 ">{{ "You must choose more than zero columns." | t }}</div>
            </div>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
export default {
    name: "client-list-settings-modal",
    data() {
        return {
            errorMsg: false
        };
    },
    computed: {
        ...mapState("ClientStore", ["listSettingsModal", "listSettingsColumns", "clientTableHeaders", "columnGroups"]),
        nameColumns() {
            return this.listSettingsColumns.filter(col => col.group === 'names');
        },
        typeColumns() {
            return this.listSettingsColumns.filter(col => col.group === 'type');
        },
        locationColumns() {
            return this.listSettingsColumns.filter(col => col.group === 'location');
        },
        businessColumns() {
            return this.listSettingsColumns.filter(col => col.group === 'business');
        }
    },
    mounted() {
        document.addEventListener("keydown", this.handleEscClick);
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleEscClick);
    },
    methods: {
        ...mapMutations("ClientStore", [
            "toggleListSettingsModal",
            "toggleListSettingsColumn",
            "setClientsTableHeaders",
            "selectAllColumns",
            "deselectAllColumns"
        ]),
        ...mapActions("UserStore", ["saveUserClientSearchColumnSettings"]),
        async handleReturnClick() {
            let counter = 0;
            await this.listSettingsColumns.forEach(x => {
                if (x.isSelected === true) counter++;
            });
            if (counter > 0) {
                await this.setClientsTableHeaders();
                await this.toggleListSettingsModal();
                await this.saveUserClientSearchColumnSettings(this.clientTableHeaders);
            } else this.errorMsg = true;
        },
        handleEscClick(e) {
            if (e.keyCode === 27 && this.listSettingsModal) {
                e.preventDefault();
                this.toggleListSettingsModal();
            }
        }
    }
};
</script>

<style scoped>
.group-header {
    font-weight: 500;
    font-size: 14px;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 4px;
    margin-bottom: 8px;
}
</style>
